import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";
import DropZone from "../components/DropZone";

function resolveSrc(u) { if (!u) return ""; if (u.startsWith("http")) return u; if (u.startsWith("/api/media/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`; return u; }

export default function AuthorBiosEditor() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/kv/author_bios").then(({ data }) => Array.isArray(data) && setItems(data));
  }, []);

  const upd = (i, k, v) => setItems((arr) => { const a = [...arr]; a[i] = { ...a[i], [k]: v }; return a; });
  const add = () => setItems((arr) => [...arr, { name: "", role: "", bio: "", linkedin: "", photo: "" }]);
  const remove = (i) => setItems((arr) => arr.filter((_, j) => j !== i));

  const save = async () => {
    setSaving(true);
    try { await api.put("/content/kv/author_bios", { value: items }); toast.success("Autores salvos."); }
    catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div>
          <h1 className="font-display text-4xl">Autores (Insights)</h1>
          <p className="text-sm text-neutral-500 mt-1">Aparece no fim de cada artigo: nome, função, bio, LinkedIn e foto. O "Nome" precisa bater com o campo "author" do insight.</p>
        </div>
        <button onClick={save} disabled={saving} data-testid="authors-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> {saving ? "Salvando…" : "Salvar"}</button>
      </div>

      <section className="border border-black/10 p-5 rounded">
        <div className="flex justify-between items-center mb-4">
          <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700">Autores ({items.length})</div>
          <button onClick={add} className="text-xs bg-accent-yellow px-3 py-1 rounded-full font-semibold" data-testid="author-add"><Plus className="w-3 h-3 inline" /> Adicionar</button>
        </div>
        <div className="space-y-4">
          {items.map((a, i) => (
            <div key={i} className="border border-black/10 p-4 rounded grid md:grid-cols-12 gap-3" data-testid={`author-${i}`}>
              <div className="md:col-span-3">
                {a.photo && <img src={resolveSrc(a.photo)} alt="" className="w-24 h-24 object-cover rounded-full mb-2 mx-auto" />}
                <DropZone multiple={false} onUploaded={(f) => upd(i, "photo", f.url)} />
                <input value={a.photo || ""} onChange={(e) => upd(i, "photo", e.target.value)} placeholder="ou URL" className="w-full text-xs border border-black/15 px-2 py-1.5 rounded mt-1" />
              </div>
              <div className="md:col-span-9 space-y-2">
                <input value={a.name || ""} onChange={(e) => upd(i, "name", e.target.value)} placeholder="Nome (precisa bater com o 'author' do insight)" className="w-full border border-black/15 px-3 py-2 rounded text-sm font-semibold" />
                <input value={a.role || ""} onChange={(e) => upd(i, "role", e.target.value)} placeholder="Função / cargo" className="w-full border border-black/15 px-3 py-2 rounded text-sm" />
                <textarea value={a.bio || ""} onChange={(e) => upd(i, "bio", e.target.value)} placeholder="Bio curta (1-3 frases)" rows={3} className="w-full border border-black/15 px-3 py-2 rounded text-sm" />
                <input value={a.linkedin || ""} onChange={(e) => upd(i, "linkedin", e.target.value)} placeholder="URL do LinkedIn" className="w-full border border-black/15 px-3 py-2 rounded text-sm" />
                <button onClick={() => remove(i)} className="text-red-500 text-xs"><Trash2 className="w-3 h-3 inline" /> Remover</button>
              </div>
            </div>
          ))}
          {!items.length && <div className="text-xs text-neutral-500 text-center py-6">Nenhum autor cadastrado.</div>}
        </div>
      </section>
    </div>
  );
}
